import CreditCard from './CreditCard'
import { Button } from './FormAddNewCreditCard/styles'
import EmptyBox from '../../components/EmptyBox'

import * as S from './styles'

const MySavedCards = ({
  addCreditCard,
  cardData,
  deleteModal,
  setCardId,
  loading,
  setCurrent
}) => {
  return (
    <S.Wrapper className="">
      <div className="content-section">
        <S.SectionTitle>Meus Cartões</S.SectionTitle>
        <div className="cards">
          {cardData?.map((card) => {
            return (
              <S.CardWrapper key={cardData?.IdFormaPagamento}>
                <CreditCard
                  data={card}
                  deleteModal={deleteModal}
                  setCardId={setCardId}
                ></CreditCard>
              </S.CardWrapper>
            )
          })}
        </div>
        {cardData.length === 0 && (
          <EmptyBox>Você não possui cartões salvos :(</EmptyBox>
        )}
        <Button
          onClick={() => {
            setCurrent(2)
          }}
        >
          Novo Cartão
        </Button>
      </div>
    </S.Wrapper>
  )
}
export default MySavedCards
